var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('AppHeader'),_c('main',{staticClass:"app-content"},[_c('router-view',{key:_vm.$route.path})],1),_c('AppFooter',{staticClass:"app-footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }